import { useEffect } from 'react';
import { Button } from '@payforge/ui';

// In-app "Discard changes?" confirmation shown when closing a dirty drawer/form. Used instead of the
// browser-native window.confirm so the prompt is styled and matches the rest of the app (mirrors the
// dialog used by the onboarding / offboarding task drawers).
export function DiscardChangesDialog({
  onDiscard,
  onCancel,
}: {
  onDiscard: () => void;
  onCancel: () => void;
}) {
  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') {
        e.stopPropagation();
        onCancel();
      }
    }
    document.addEventListener('keydown', onKey, true);
    return () => document.removeEventListener('keydown', onKey, true);
  }, [onCancel]);

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/40">
      <div className="w-[min(24rem,95vw)] rounded-xl border border-slate-200 bg-surface p-6">
        <h3 className="text-base font-semibold text-slate-900">Discard changes?</h3>
        <p className="mt-2 text-sm text-slate-600">Anything you&apos;ve entered will be lost.</p>
        <div className="mt-5 flex justify-end gap-3">
          <Button size="md"
            variant="tertiary"
            onClick={onCancel}
            data-testid="discard-cancel-btn"
          >
            Cancel
          </Button>
          <Button size="md"
            variant="danger"
            onClick={onDiscard}
            data-testid="discard-confirm-btn"
          >
            Discard
          </Button>
        </div>
      </div>
    </div>
  );
}
